import { TrendingDown, TrendingUp, PackageMinus, AlertOctagon, FileText, Warehouse } from 'lucide-react';
import { fmtKc, pctChange } from './k2utils';

const Delta = ({ cur, prev, inverse, testId }) => {
  const p = pctChange(cur, prev);
  if (p == null) return <span className="text-xs text-[#94A3B8]" data-testid={testId}>bez srovnání</span>;
  const up = p >= 0;
  const bad = inverse ? up : !up;
  const Icon = up ? TrendingUp : TrendingDown;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 text-xs font-semibold ${bad ? 'text-[#DC2626]' : 'text-[#16A34A]'}`}>
      <Icon className="w-3.5 h-3.5" /> {up ? '+' : ''}{p.toFixed(1)} %
    </span>
  );
};

const Kpi = ({ icon: Icon, label, value, sub, testId, accent }) => (
  <div className="bg-white border border-[#E2E8F0] rounded-2xl p-4 shadow-sm" data-testid={testId}>
    <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-[#57534E]">
      <Icon className="w-4 h-4" style={{ color: accent }} /> {label}
    </div>
    <div className="mt-2 text-2xl font-bold text-[#052E16] font-['Manrope'] tabular-nums" data-testid={`${testId}-value`}>{value}</div>
    <div className="mt-1 min-h-[18px]">{sub}</div>
  </div>
);

export const K2Kpis = ({ cur, prev, nesTotal, showCompare }) => (
  <div className="grid grid-cols-2 lg:grid-cols-5 gap-3" data-testid="k2-kpis">
    <Kpi icon={PackageMinus} accent="#16A34A" label="Pohyby celkem" value={fmtKc(cur.moves)} testId="k2-kpi-moves"
      sub={showCompare && <Delta cur={cur.moves} prev={prev.moves} testId="k2-kpi-moves-delta" />} />
    <Kpi icon={FileText} accent="#0EA5E9" label="Výdeje 290" value={fmtKc(cur.b290)} testId="k2-kpi-290"
      sub={showCompare && <Delta cur={cur.b290} prev={prev.b290} testId="k2-kpi-290-delta" />} />
    <Kpi icon={FileText} accent="#8B5CF6" label="Výdeje 291" value={fmtKc(cur.b291)} testId="k2-kpi-291"
      sub={showCompare && <Delta cur={cur.b291} prev={prev.b291} testId="k2-kpi-291-delta" />} />
    <Kpi icon={AlertOctagon} accent="#DC2626" label="Ztráty NES (dle šarže)" value={fmtKc(cur.losses)} testId="k2-kpi-losses"
      sub={showCompare && <Delta cur={cur.losses} prev={prev.losses} inverse testId="k2-kpi-losses-delta" />} />
    <Kpi icon={Warehouse} accent="#F59E0B" label="Sklad NES – aktuálně" value={fmtKc(nesTotal)} testId="k2-kpi-nes-total"
      sub={<span className="text-xs text-[#94A3B8]">celková účetní hodnota</span>} />
  </div>
);
